import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
/***** Models *****/
import { EmployeeInfo } from 'src/app/models/options';
/***** Rxjs *****/
import { BehaviorSubject, Observable, Subject } from 'rxjs';
/***** Services *****/
import { ImgService } from './img.service';

export interface SiteInfo {
  site_uniform_no?: string; // 公司統編
  site_company_no?: string; // 公司編碼
  site_full_name?: string; // 公司全稱
  site_short_name?: string; // 公司簡稱
  site_logo?: any; // 公司logo
}

export interface RouteInfo {
  program_no?: string; // 程式功能編號
  program_title?: string; // 程式功能名稱
}

export interface Marquee {
  serial?: number;
  content?: string;
  siteUrl?: string;
}

export interface Loading {
  mode: boolean;
  text: string;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  isDemo = false;

  /***** App Version *****/
  pc_version = '0.1.3';
  mobile_version = '0.0.1';

  /***** Site Info *****/
  siteInfo$ = new BehaviorSubject<SiteInfo>(null);

  /***** Loading *****/
  isLoading$ = new BehaviorSubject<Loading>({mode: false, text: '' });

  /***** Button Modes 按鈕模式
   * -1: 按鈕全部禁止
   * 0: 查詢V-新增V-修改X-刪除X-儲存X-取消X-列印X-轉出X (瀏覽模式-未選擇資料)
   * 1: 查詢V-新增V-修改V-刪除V-儲存X-取消X-列印V-轉出V (瀏覽模式-已選擇資料)
   * 2: 查詢X-新增X-修改X-刪除X-儲存V-取消V-列印X-轉出X (新增模式)
   * 3: 查詢X-新增X-修改X-刪除X-儲存V-取消V-列印X-轉出X (修改模式)
   *****/
  buttonMode$ = new BehaviorSubject<-1|0|1|2|3>(0);

  /***** 跑馬燈資訊 *****/
  marqueeList$ = new BehaviorSubject<Marquee[]>([]);

  /*** Current Route Info ***/
  currentRouteInfo$ = new BehaviorSubject<RouteInfo>(null);

  constructor(
    @Inject(DOCUMENT) private doc,
    private titleService: Title,
    private imgService: ImgService,
  ) {}

  /***** Marquee *****/
  setMarqueeList(value: Marquee[]): void {
    this.marqueeList$.next(value);
  }
  getMarqueeList(): Observable<Marquee[]> {
    return this.marqueeList$;
  }

  /***** Loading *****/
  setLoadingMode(mode: boolean, text?: string) {
    this.isLoading$.next({mode, text});
    return mode;
  }
  getLoadingMode(): Observable<Loading> {
    return this.isLoading$;
  }

  /***** Button Mode *****/
  setButtonMode(mode: -1|0|1|2|3) {
    this.buttonMode$.next(mode);
  }
  getButtonMode(): Observable<-1|0|1|2|3> {
    return this.buttonMode$;
  }

  /***** Site Info *****/
  setSiteInfo(siteInfo) {
    // console.log(siteInfo);
    const site_full_name = siteInfo.site_full_name ? siteInfo.site_full_name : '';
    const site_short_name = siteInfo.site_short_name ? siteInfo.site_short_name : '';
    const site_uniform_no = siteInfo.site_uniform_no;
    // const site_logo = siteInfo.smc20 ? ('data:image/jpeg;base64,' + this.imgService.base64ArrayBuffer(siteInfo.smc20.data)) : '';
    // const site_logo = 'assets/svg/logo.svg';
    const site_logo = siteInfo.site_logo;
    this.siteInfo$.next({
      site_full_name, 
      site_short_name, 
      site_uniform_no, site_logo
    });
    /*** 更改網頁Tab名稱 ***/
    // this.titleService.setTitle(site_short_name);
    /*** 更改網頁Tab Icon ***/
    // this.doc.getElementById('appFavicon').setAttribute('href', 'data:image/x-icon;base64,' + site_logo.split(',')[1]);
  }
  getSiteInfo(): Observable<SiteInfo> {
    return this.siteInfo$;
  }

  /***** Route Info *****/
  setCurrentRouteInfo(value: RouteInfo)  {
    this.currentRouteInfo$.next(value);
  }
  getCUrrentRouteInfo(): Observable<RouteInfo> {
    return this.currentRouteInfo$;
  }

}
